var app = angular.module("leonardo");
var SSOCallback = function($stateProvider) {
  $stateProvider.state('sso-callback', {
    parent: 'layout-no-cols',
    url: "/sso-callback",
    cssClass: 'page-home',
    resolve: {
      deviceCheck: ['deviceDetector', '$state', 'blockUI', '$http', 'ConfigThemeService', '$location', 'NotificationService', '$timeout', '$q',
      function(deviceDetector, $state, blockUI, $http, ConfigThemeService, $location, NotificationService, $timeout, $q) {
        var deferred = $q.defer();
        
        if (!deviceDetector.isMobile() && !deviceDetector.isTablet()) {
          // For web users: handle JWT and redirect without showing the page
          blockUI.start();
          
          var sessionId = $location.search().session_id;
          if (!sessionId) {
            blockUI.stop();
            $state.go('home', {}, { location: 'replace' });
            deferred.reject();
            return deferred.promise;
          }

          var url = ConfigThemeService.generateURL('/get-jwt');
          $http.get(url, { params: { session_id: sessionId } })
            .then(function(response) {
              blockUI.stop();
              let token =  (response && response.data && response.data.token) ? response.data.token : null;
              if(token) {
                localStorage.setItem('jwt_token', token);
                localStorage.setItem('session_id', sessionId);
              }
              localStorage.setItem('auth_provider', 'SSO');
              $timeout(function() {
                $state.go('home', {}, { location: 'replace' });
              }, 0);
              deferred.reject();
            })
            .catch(function(error) {
              blockUI.stop();
              if (error && error.data) {
                NotificationService.error(error.data);
                $timeout(function() {
                  $state.go('home', {}, { location: 'replace' });
                }, 2000);
              }
              deferred.reject();
            });
          return deferred.promise;
        }

        // For mobile/tablet: allow the page to render
        deferred.resolve(true);
        return deferred.promise;
      }]
    },
    views: {
      'content': {
        templateUrl: 'views/templates/user/sso-callback.html',
        controller: 'SSOCallbackController'
      }
    },
    public: true
  });
};

app.config(['$stateProvider', SSOCallback]);
